module.exports = __webpack_public_path__ + "img/icon-Social3.8f8bb045.png";